import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-delete-account-modal',
  templateUrl: './delete-account-modal.component.html',
  styleUrls: ['./delete-account-modal.component.scss'],
})
export class DeleteAccountModalComponent implements OnInit {

  @Input() modeFrom:any;
  @Input() msg:any;
  constructor(private mdlCtrl:ModalController) { }

  ngOnInit() {}

  // Dismiss Modal
  back(){
    this.mdlCtrl.dismiss();
  }

  // Save Action Modal Dismiss
  actionDismiss(){
    this.mdlCtrl.dismiss(true)
  }
}
